export enum Role {
	//Global
	Accounting = 'Accounting',
	Administrator = 'Administrator',
	ProfessionalServices = 'ProfessionalServices',
	Developer = 'Developer',
	Employee = 'Employee',
	Operations = 'Operations',
	GlobalAccountStandardFeatureSet = 'GlobalAccountStandardFeatureSet',
	GlobalAccountAdvancedFeatureSet = 'GlobalAccountAdvancedFeatureSet',
	OperationsStandardFeatureSet = 'OperationsStandardFeatureSet',
	OperationsAdvancedFeatureSet = 'OperationsAdvancedFeatureSet',
	OperationsExpertFeatureSet = 'OperationsExpertFeatureSet',
	//Account roles
	AccountFeatureSet = 'AccountFeatureSet',
	AuditDocFeatureSet = 'AuditDocFeatureSet',
	DeleteDocFeatureSet = 'DeleteDocFeatureSet',
	DocReviewFeatureSet = 'DocReviewFeatureSet',
	EditFeatureSet = 'EditFeatureSet',
	EditMetadataFeatureSet = 'EditMetadataFeatureSet',
	LimitedFeatureSet = 'LimitedFeatureSet',
	ManageCustomDocFieldsFeatureSet = 'ManageCustomDocFieldsFeatureSet',
	PowerUploadFeatureSet = 'PowerUploadFeatureSet',
	PredictiveCodingFeatureSet = 'PredictiveCodingFeatureSet',
	StandardFeatureSet = 'StandardFeatureSet',
}

export enum RoleGuid {
	//Account roles
	AccountFeatureSet = '67c74a33-2988-4adb-beaf-f7cd8146d446',
	AuditDocFeatureSet = 'd2c3d7db-31b5-419d-b2f6-fb439257c31a',
	DeleteDocFeatureSet = 'fbbc3abb-7d0e-47e3-bbb1-7afa885f364d',
	DocReviewFeatureSet = 'cca9ce99-9842-4daa-b078-62f8b843a845',
	EditFeatureSet = '9711a306-9640-4f55-b6ed-6ecdfe34393d',
	EditMetadataFeatureSet = 'd992d32c-2428-49e8-80c9-c0216ba48c1a',
	LimitedFeatureSet = 'f5697fbe-3de7-4167-bba9-be98c206e954',
	ManageCustomDocFieldsFeatureSet = '4b2c7f02-6711-4a33-b140-6b17b96d61d9',
	PowerUploadFeatureSet = '2d44abe2-2a20-4ab3-a288-e190e51515e8',
	PredictiveCodingFeatureSet = 'c815e653-e1ed-42f6-a9a3-b05f47d8ddb2',
	StandardFeatureSet = '95b0ce53-f4d9-48c5-b84f-e431ca096287',
}
